import { css } from "lit";
// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:block}.editor{height:100%}.editor.minimal{display:flex;flex-direction:column;justify-content:center}.editor.minimal .cm-content{align-self:center;min-height:auto}.editor.minimal .cm-focused{outline:none}.editor.minimal .cm-line{padding:0 12px}.editor .cm-editor{height:100%;width:100%}:is(.editor .cm-editor) *{font-family:var(--font-family-code)!important}`, ""]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
